import React, {Component} from 'react';
import { 
    Row, 
    Col, 
    Card, 
    CardBody, 
    CardTitle, 
    CardSubtitle,
    Button,
    Nav,
    NavItem,
    TabContent, TabPane,
    Input,
    Label,
} from "reactstrap";
import { Link, NavLink } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import swal from 'sweetalert';
import {Table, Thead, Tbody, Tr, Th, Td} from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import Select from "react-select";
import makeAnimated from 'react-select/animated';
import LoadingScreen from 'react-loading-screen';
import ReactECharts from 'echarts-for-react';
import moment from 'moment-timezone';
import Breadcrumbs from '../../component/Breadcrumb';
import classNames from 'classnames';
import{
    showInOut,
    limitDefault,
    //urlBackend,
    infoSession,
    toAngka,
    saveTanggal,
    showTanggal,
    showTanggalJam,
    formatBytes,
    //jsonToUpperCase
} from '../../config/Utils';
import classnames from "classnames";
import logo from "../../images/logo/blank.png";
import user1 from '../../images/users/no-pic.png';
import API from '../../helpers/API';
moment.tz.setDefault("Asia/Makassar");
var no_record=1;
const date_now = new Date();

const style = {
  height: "90vh",
  width: "100%"
};

const optionsPie ={
    tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    /*legend: {
        data: [
            'Gambar',
            'Video',
            'Musik',
            'Dokumen',
            'File Lainnya'
        ]
    },*/
    series: [{
        name: 'Ketersedian Hardisk',
        type: 'pie',
        selectedMode: 'single',
        radius: [0, '30%'],
        label: {
            position: 'inner',
            fontSize: 14
        },
        labelLine: {
            show: false
        },
        data: [
            { value: 1548, name: 'Kosong' },
            { value: 775, name: 'Terpakai', selected:true }
        ]
    }]
}

class Dashboard extends Component {
	constructor(props) {
        super(props);
        this.state={
            isReady:false,
            isLoading:false,
            produkIn:0,
            produkOut:0,
            dataTableActivity:[],
            tgl:date_now
        }
    }

    notif(type,title,message){
        swal({
            title: title,
            text: message,
            icon: type,
        });
    }

    _loading(status){
        this.setState({
            isLoading:status
        });
    }

    _loadSumProduk(){
        var filter = {
            tgl:saveTanggal(date_now)
        };

        API.get('dashboard/summary',{params:filter}).then(res=>{
            if(res.data.result){
                var x = res.data.data;
                this.setState({
                    produkIn:x.produk_in[0],
                    produkOut:x.produk_out[0]
                })
            }

        });

    }

    _loadActivity(){
        var filter = {
            tgl:saveTanggal(date_now)
        };

        let ar = [];
        API.get('dashboard/last-activity',{params:filter}).then(res=>{
            if(res.data.result){
                if(res.data.data.length){
                    ar = res.data.data;
                };
                this.setState({
                    dataTableActivity:ar
                })
            }
        });
    }

    componentDidMount() {
        if(this.state.isLoading){
            this.setState({
                isReady:true,
                isLoading:false
            });
        }
    }

    render() {
        if(!this.state.isReady){
            this.setState({
                isReady:true
            });

            this._loadSumProduk();
            this._loadActivity();
        }
        return(
        	<React.Fragment>
            <LoadingScreen
                    loading={this.state.isLoading}
                    bgColor='#f1f1f1'
                    spinnerColor='#9ee5f8'
                    textColor='#676767'
                    logoSrc={logo}
                    text=''
            >
        		<Breadcrumbs title="" breadcrumbItem="DASHBOARD" />

                <Row>
                    <Col className='col-xl-4 col-sm-12'>
                        <div className='card bg-primary bg-soft'>
                            <div className='row'>
                                <div className='col-7'>
                                    <div className='text-primary p-3'>
                                        <h5 style={{color:"#ffffff"}}>Welcome back</h5>
                                    </div>
                                </div>
                                <div className='col-5 align-self-end'>
                                    <img src='assets/images/profile-img.png' className='img-fluid'></img>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col className='col-xl-4 col-sm-12'>
                        <div className='card'>
                            <div className='card-body'>
                                <div className='d-flex align-items-center mb-3'>
                                    <div className='avatar-xs mr-3'>
                                        <span className='avatar-title rounded-circle font-size-18'>
                                            <i className='fas fa-info-circle'></i>
                                        </span>
                                    </div>
                                    <h5 className='font-size-14 mb-0'>Product IN</h5>
                                </div>
                                <div className='text-muted mt-4 center'><h4 style={{textAlign:'center'}}>{this.state.produkIn}</h4></div>
                            </div>
                        </div>
                    </Col>
                    <Col className='col-xl-4 col-sm-12'>
                    <div className='card'>
                            <div className='card-body'>
                                <div className='d-flex align-items-center mb-3'>
                                    <div className='avatar-xs mr-3'>
                                        <span className='avatar-title rounded-circle font-size-18'>
                                            <i className='fas fa-info-circle'></i>
                                        </span>
                                    </div>
                                    <h5 className='font-size-14 mb-0'>Product OUT</h5>
                                </div>
                                <div className='text-muted mt-4 center'><h4 style={{textAlign:'center'}}>{this.state.produkOut}</h4></div>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <div className='card'>
                            <div className='card-body'>
                                <div className='row'>
                                    <div className='col-lg-12'>
                                        <div className='d-flex'><h4 className='card-title mb-4 flex-grow-1'>Last Activity</h4></div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-lg-12'>
                                        <div className="table-responsive">
                                            <table className="table align-middle table-nowrap table-hover mb-0">
                                                <thead>
                                                    <tr>
                                                        <th scope="col" style={{width:'50px'}}>IN/OUT</th>
                                                        <th scope="col" style={{width:'150px'}}>DATE</th>
                                                        <th scope="col" >PRODUCT</th>
                                                        <th scope="col" >DESCRIPTION</th>
                                                        <th scope="col" style={{width:'100px'}}>QTY</th>
                                                        <th scope="col" style={{width:'100px'}}>UNIT</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.dataTableActivity.map((item, index)=>{
                                                            console.log(item);
                                                            return(
                                                                <React.Fragment key={"f_"+index}>
                                                                    <tr key={'row_'+index}>
                                                                        <td>{showInOut(item[9])}</td>
                                                                        <td>{showTanggalJam(item[1])}</td>
                                                                        <td>{"["+item[10]+"] "+item[11]}</td>
                                                                        <td>{item[6]}</td>
                                                                        <td>{item[7]}</td>
                                                                        <td>{item[8]}</td>
                                                                    </tr>
                                                                </React.Fragment>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </LoadingScreen>
        	</React.Fragment>
        )
    }

}
export default Dashboard;